import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { client } from "shared/helpers/client";
import { useAuthContext } from "shared/context/auth-context";
import { toast } from "react-toastify";
import { passwordPattern } from "shared/helpers/utils";

interface ChangePasswordData {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export function useChangePassword() {
  const { t } = useTranslation();
  const { mutate: callChangePasswordServer,isLoading } = useMutation((data: any) =>
    client("/Owner/ChangePassword", { data })
  );

  const schema = React.useMemo(() => {
    return yup.object().shape({
      oldPassword: yup.string().required(t("errors.required")),
      newPassword: yup.string().required(t("errors.required")).matches(passwordPattern,t('errors.invalid-password')),
      confirmNewPassword: yup
        .string()
        .required(t("errors.required"))
        .equals([yup.ref("newPassword")],t('errors.password-mismatch')),
    });
  }, [t]);

  const methods = useForm<ChangePasswordData>({
    resolver: yupResolver(schema),
  });

  function changePassword(data: ChangePasswordData) {
    const changePasswordDto = {
      currentPassword: data.oldPassword,
      password: data.newPassword,
    };
    callChangePasswordServer(changePasswordDto, {
      onSuccess({ error, response }) {
        if (error) toast.error(t("errors.server-error"));
        if (response) toast.success(t("form.save-success"));
      },
    });
  }

  return { ...methods, handleSubmit: methods.handleSubmit(changePassword),isLoading };
}
